import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableDashboardRecalculationRoutes = Loadable(
  './DashboardRecalculationRoutes',
  () => import(/* webpackChunkName: "DashboardRecalculation" */ './DashboardRecalculationRoutes'),
  () => [(require as any).resolveWeak('./DashboardRecalculationRoutes')]
);
